module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-content"
  }, [_c('Selector', {
    ref: "Selector",
    attrs: {
      "petitionSelector": _vm.petitionSelector,
      "donationSelector": _vm.donationSelector,
      "petitionHandle": _vm.petitionHandle
    },
    on: {
      "firstTouch": function($event) {
        _vm.logFirstTouch('leaf relief type')
      }
    }
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "wwf-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supporter.firstName),
      expression: "supporter.firstName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      error: _vm.errors.has('firstName'),
        empty: !_vm.supporter.firstName,
    },
    attrs: {
      "name": "firstName",
      "type": "text",
      "data-vv-as": "first name",
      "placeholder": " ",
      "autocomplete": "given-name"
    },
    domProps: {
      "value": (_vm.supporter.firstName)
    },
    on: {
      "focus": function($event) {
        _vm.logFirstTouch('first name')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supporter, "firstName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "firstName"
    }
  }, [_vm._v("First Name*")]), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.has('firstName')) ? _c('p', [_vm._v("\n            " + _vm._s(_vm.errors.first("firstName")) + "\n          ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "wwf-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supporter.lastName),
      expression: "supporter.lastName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      error: _vm.errors.has('lastName'),
        empty: !_vm.supporter.lastName,
    },
    attrs: {
      "name": "lastName",
      "type": "text",
      "data-vv-as": "last name",
      "placeholder": " ",
      "autocomplete": "family-name"
    },
    domProps: {
      "value": (_vm.supporter.lastName)
    },
    on: {
      "focus": function($event) {
        _vm.logFirstTouch('last name')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supporter, "lastName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "lastName"
    }
  }, [_vm._v("Last Name*")]), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.has('lastName')) ? _c('p', [_vm._v("\n            " + _vm._s(_vm.errors.first("lastName")) + "\n          ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "wwf-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supporter.email),
      expression: "supporter.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        leafReliefCheckEmail: true
      }),
      expression: "{ required: true, leafReliefCheckEmail: true }"
    }],
    class: {
      error: _vm.errors.has('email'),
        empty: !_vm.supporter.email,
    },
    attrs: {
      "id": "email",
      "name": "email",
      "type": "email",
      "placeholder": " ",
      "autocomplete": "email"
    },
    domProps: {
      "value": (_vm.supporter.email)
    },
    on: {
      "focus": function($event) {
        _vm.logFirstTouch('email')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supporter, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email*")]), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.has('email')) ? _c('p', [_vm._v("\n            " + _vm._s(_vm.errors.first("email")) + "\n          ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "wwf-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supporter.postcode),
      expression: "supporter.postcode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        alpha_num: true
      }),
      expression: "{ required: true, alpha_num: true }"
    }],
    class: {
      error: _vm.errors.has('postcode'),
        empty: !_vm.supporter.postcode,
    },
    attrs: {
      "name": "postcode",
      "type": "text",
      "data-vv-as": "postcode",
      "placeholder": " ",
      "autocomplete": "postal-code"
    },
    domProps: {
      "value": (_vm.supporter.postcode)
    },
    on: {
      "focus": function($event) {
        _vm.logFirstTouch('postcode')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supporter, "postcode", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "postcode"
    }
  }, [_vm._v("Postcode*")]), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.has('postcode')) ? _c('p', [_vm._v("\n            " + _vm._s(_vm.errors.first("postcode")) + "\n          ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "wwf-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supporter.phoneNumber),
      expression: "supporter.phoneNumber"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      error: _vm.errors.has('phone'),
        empty: !_vm.supporter.phoneNumber,
    },
    attrs: {
      "name": "phone",
      "type": "tel",
      "min": "8",
      "max": "12",
      "data-vv-as": "phone",
      "placeholder": " ",
      "autocomplete": "tel"
    },
    domProps: {
      "value": (_vm.supporter.phoneNumber)
    },
    on: {
      "focus": function($event) {
        _vm.logFirstTouch('phone')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supporter, "phoneNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Phone*")]), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.has('phone')) ? _c('p', [_vm._v("\n            " + _vm._s(_vm.errors.first("phone")) + "\n          ")]) : _vm._e()])]), _vm._v(" "), _c('label', {
    staticClass: "checkbox"
  }, [_vm._v("\n        Yes, display my name\n        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supporter.agreesDisplayName),
      expression: "supporter.agreesDisplayName"
    }],
    attrs: {
      "type": "checkbox",
      "name": "displayName",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.supporter.agreesDisplayName) ? _vm._i(_vm.supporter.agreesDisplayName, null) > -1 : (_vm.supporter.agreesDisplayName)
    },
    on: {
      "focus": function($event) {
        _vm.logFirstTouch('display my name')
      },
      "change": function($event) {
        var $$a = _vm.supporter.agreesDisplayName,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.supporter.agreesDisplayName = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.supporter.agreesDisplayName = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.supporter, "agreesDisplayName", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])]), _vm._v(" "), (_vm.isEmailInError) ? _c('div', {
    staticClass: "submit-email-error"
  }, [_c('p', [_vm._v(_vm._s(_vm.duplicateEmailMessage))])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "plain",
    attrs: {
      "type": "button",
      "name": "stepOneNext",
      "href": "#form-top"
    },
    on: {
      "click": function($event) {
        _vm.next()
      }
    }
  }, [(!_vm.isSaving) ? _c('span', [_vm._v("\n        " + _vm._s(_vm.isDonation ? _vm.donationSelector : _vm.petitionSelector) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.isSaving) ? _c('span', [_c('i', {
    staticClass: "far fa-spinner-third fa-spin"
  })]) : _vm._e()]), _vm._v(" "), _vm._m(0, false, false)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "privacy-statement"
  }, [_c('p', [_vm._v("\n        By signing you accept\n        "), _c('a', {
    attrs: {
      "href": "/privacy-policy/privacy-policy",
      "target": "_blank"
    }
  }, [_vm._v("\n          WWF-Australia’s Privacy Policy.\n        ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c669cae","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=v6bwv9n4fgn!./~/string-replace-webpack-plugin/loader.js?id=oue8yteht5p!./src/components/leaf-relief/Details.vue
// module id = 635
// module chunks = 0